import { faInfoCircle, faTimes } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo } from "react";
import { DataTable } from "capitalroadkit";
import Tooltip from "@material-ui/core/Tooltip";
import { parseCamelCase, toPercentString } from "../../../resources/formatters/Formatter";

const ActivityComponentsTable = ({ data, remove }) => {
  const columns = useMemo(
    () => [
      {
        id: "ActivityComponentsTable",
        columns: [
          {
            accessor: "componentType.description",
            Header: "Component type",
          },
          {
            accessor: "volumeCalculator.perShare",
            Header: "Rate per share",
            Cell: ({ cell: { value }, row: { original } }) => (
              <Tooltip
                placement="bottom-start"
                title={
                  <table
                    style={{
                      borderCollapse: "collapse",
                      tableLayout: "fixed",
                      textAlign: "left",
                      width: "100%",
                    }}
                  >
                    {Object.entries(original.volumeCalculator).map((obj) => (
                      <tr>
                        <th>{parseCamelCase(obj[0])}:</th>
                        <td>{obj[1]}</td>
                      </tr>
                    ))}
                  </table>
                }
              >
                <div>
                  {value} <FontAwesomeIcon icon={faInfoCircle} />
                </div>
              </Tooltip>
            ),
          },
          {
            accessor: "taxRate",
            Header: "Tax rate",
            Cell: ({ value }) => toPercentString(value),
          },
          {
            id: "actions",
            rightAlign: true,
            Cell: ({ row: { original } }) => (
              <div onClick={() => remove(original.uuid)} style={{ cursor: "pointer" }}>
                <FontAwesomeIcon icon={faTimes} />
              </div>
            ),
          },
        ],
      },
    ],
    []
  );

  return (
    <DataTable
      size={"small"}
      columns={columns}
      hiddenColumns={remove ? [undefined] : ["actions"]}
      data={data}
      pagination={false}
    />
  );
};

export default ActivityComponentsTable;
